export default __webpack_public_path__ + "static/media/bannershortened1.2a447917.png";